<template>
  <div class="notification is-danger">
    <button class="delete" @click='$emit("clear")'></button>
    <ol>
      <li v-for='message in messages' :key='message'>
        <div><strong>Error:</strong> {{ message.error }}</div>
        <div><strong>Email Type:</strong> {{ message.emailType }}</div>
        <div><strong>Send Via:</strong> {{ message.sendVia }}</div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'TestingErrorsNotification',

  props: {
    messages: {
      type: Array,
      required: true
    }
  }
}
</script>
